import { css } from '@bts-web/utils-style-engine';
import { Drawer } from '../../common/components/Drawer/Drawer';
import { FilledExclamationMark } from '../../common/svgIcons/FilledExclamationMark';
import { AcceptOrderTranslations } from './getTranslations';
import { ButtonBase } from '@bts-web/core-features/common';

interface SummaryInfoDrawer {
  translations: AcceptOrderTranslations;
  customTitle: string;
  subtitle1: string;
  subtitle2: string;
  onClose: () => void;
}

export const SummaryInfoDrawer = ({
  translations,
  customTitle,
  subtitle1,
  subtitle2,
  onClose,
}: SummaryInfoDrawer) => {
  return (
    <Drawer>
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 'medium',
        })}
      >
        <FilledExclamationMark size={48} />
        <span
          className={css({
            textAlign: 'center',
            paddingTop: 'small',
            paddingBottom: 'small',
            fontSize: 'headline.medium_medium',
            fontWeight: 'headline.medium_medium',
            lineHeight: 'headline.medium_medium',
          })}
        >
          {customTitle}
        </span>
        <span
          className={css({
            textAlign: 'center',
            paddingBottom: 'extra_small_2',
            fontSize: 'body.medium',
            fontWeight: 'body.medium',
            lineHeight: 'body.medium',
          })}
        >
          {subtitle1}
        </span>
        <span
          className={css({
            textAlign: 'center',
            paddingBottom: 'medium',
            fontSize: 'body.medium',
            fontWeight: 'body.medium',
            lineHeight: 'body.medium',
          })}
        >
          {subtitle2}
        </span>
        <ButtonBase onClick={onClose}>{translations.okGotIt}</ButtonBase>
      </div>
    </Drawer>
  );
};
